import React from 'react'
import { Form } from 'react-bootstrap'
import InputMask from "react-input-mask";
import styled from 'styled-components'
import Text from "../../../../../_components/Text"
import { formatDocument, formatPhoneNumber } from '../../../../../utils';
import { getClients } from "../../../../../api/clients"
import Button from '../../../../../_components/Button';

const Label = styled.p`
font-family: roboto;
font-size: 1.1em;
`
export default class FilterClients extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            params: {
                end_count: 10
            },
            fields: [
                {
                    "name": "name",
                    "label": "Nome",
                    "type": "text",
                    cyTest: "#filter-client-input-name"
                },
                {
                    "name": "cpf_cnpj",
                    "label": "CPF/CNPJ",
                    "type": "text",
                    "maxLength": 18,
                    cyTest: "#filter-client-input-cpf-cnpj"
                },
                {
                    "name": "email",
                    "label": "E-mail",
                    "type": "email",
                    cyTest: "#filter-client-input-email"
                },
                {
                    "name": "phone_number",
                    "label": "Telefone",
                    "type": "text",
                    "mask": "(99) 99999-9999",
                    cyTest: "#filter-client-input-phone-number"
                },
                {
                    "name": "end_count",
                    "label": "Exibir até:",
                    "type": "select",
                    "options": [10, 20, 30, 50, 100, 150]
                },

            ],
            searchResult: [],
            loading: false,
            lastFieldUsed: "",
            isToggled: true
        }
        this.onChange = this.onChange.bind(this)
        this.filter = this.filter.bind(this)
    }
    handleToggle = () => {
        this.setState(prevState => ({
            isToggled: !prevState.isToggled
        }));
    }
    onChange(e) {
        const { params } = this.state
        let { name: key, value } = e.target
        if (key === "phone_number" || key === "cpf_cnpj") {
            value = value.replace(/\D+/g, "")
        }
        params[key] = value
        this.setState({ params, lastFieldUsed: key })
    }
    async filter() {
        this.setState({ loading: true, searchResult: [] })

        await getClients(this.state.params)
            .then(searchResult => {
                this.setState({ searchResult, loading: false })
                this.handleSetFocusOnLastFieldUsed()
            })
            .catch(() => {
                this.handleSetFocusOnLastFieldUsed()
                this.setState({ loading: false })
            })
    }
    handleSetFocusOnLastFieldUsed() {
        if (this.state.lastFieldUsed) {
            try {
                document.querySelector(`[name="${this.state.lastFieldUsed}"]`).focus()
            } catch (error) { }
        }
    }
    onRowClick(item) {
        this.props.onClick(item)
        this.setState({ searchResult: [] })
    }
    render() {
        return <React.Fragment>
            {
                this.props.showTitle
                    ? <div className="row">
                        <div className="col-12">
                            <Label>
                                Pesquisar Cliente
                            </Label>
                        </div>
                    </div>
                    : <span />
            }
            <Form.Check
                className="mb-2"
                type="switch"
                id="toggled"
                label={this.state.isToggled ? <Text className="form-label" >Pesquisa simplificada</Text> : <Text className="form-label" >Pesquisa padrão</Text>}
                checked={this.state.isToggled}
                onClick={this.handleToggle}
            />
            <div className="row">
                {
                    this.state.fields.map((field, index) => {
                        const key = `clients-list-index-${index}`
                        if (field.type === "select") {
                            return <div data-cy-test={field.cyTest} className={`col-md-6 col-xs-12 ${this.state.isToggled && field.label == "Exibir até:" ? "d-none" : ""}`} key={key}>
                                <Form.Group>
                                    <Form.Label>{field.label}</Form.Label>
                                    <Form.Control
                                        onChange={this.onChange}
                                        disabled={this.state.loading}
                                        name="end_count"
                                        as="select">
                                        {
                                            field.options.map((option, index) => {
                                                return <option
                                                    key={index}
                                                    value={option}>{option} resultados</option>
                                            })
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </div>
                        }
                        return <div className="col-md-6 col-xs-12" key={key}>

                            <Form.Group
                                className={`
                                ${this.state.isToggled && field.label == "E-mail" ||
                                        this.state.isToggled && field.label == "Telefone" ? "d-none" : ""}
                                `}>
                                <Form.Label>{field.label}</Form.Label>
                                <InputMask
                                data-cy-test={field.cyTest}
                                    maxLength={field.maxLength}
                                    disabled={this.state.loading}
                                    mask={field.mask}
                                    className="form-control"
                                    name={field.name}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            this.filter()
                                        }
                                    }}
                                    value={this.state.params[field.name]}
                                    onChange={this.onChange}
                                />
                            </Form.Group>
                        </div>
                    })
                }

                <div className="col-12 text-right">
                    <Button
                    data-cy-test="#filter-client-button-search"
                        onClick={this.filter}
                        disabled={this.state.loading} >
                        {this.state.loading ? "Pesquisando ... " : "Pesquisar Cliente"}
                        {
                            this.state.loading
                                ? <span className='fas fa-spinner fa-spin ml-3' />
                                : <span className='fas fa-search ml-3' />
                        }
                    </Button>
                </div>
                <div className={`${this.state.searchResult.length ? "col-12" : "d-none"}`}>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>CPF/CNPJ</th>
                                    <th>E-mail</th>
                                    <th>Telefone</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.searchResult.map((result, index) => {
                                        if (result.company) {
                                            result.cpf_cnpj = result.company.cnpj
                                        } else {
                                            result.cpf_cnpj = result.individual.cpf
                                        }
                                        result.cpf_cnpj = formatDocument(result.cpf_cnpj)
                                        result.formatedPhoneNumber = formatPhoneNumber(result.phone_number)

                                        return <tr
                                        data-cy-test={`#filter-client-list-result-index=${index}`}
                                            style={{ cursor: 'pointer' }}
                                            title={result.name}
                                            onClick={() => this.onRowClick(result)} key={index}>
                                            <td>{result.name}</td>
                                            <td>{result.cpf_cnpj}</td>
                                            <td>{result.email}</td>
                                            <td>{result.formatedPhoneNumber? result.formatedPhoneNumber : result.phone_number}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/components/Filter/index.jsx